module.exports = __webpack_public_path__ + "static/media/truck-icon.682d1a86.svg";